import moment from 'moment';

/**
 * Formats seconds to HH:mm:ss format
 * @param {number} seconds - The number of seconds
 * @returns {string} The formatted time
 */
export const formatSeconds = (seconds) => {
  return moment.utc(seconds * 1000).format('HH:mm:ss');
};

/**
 * Formats seconds to HH:mm:ss.mmm format
 * @param {number} seconds - The number of seconds
 * @param {string} msDelimiter - The delimiter for milliseconds (default: '.')
 * @returns {string} The formatted time with milliseconds
 */
export const formatSecondsWithMs = (seconds, msDelimiter = '.') => {
  let negative = false;
  if (seconds < 0) {
    seconds = seconds * -1;
    negative = true;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  const ms = Math.round((seconds % 1) * 1000);

  const formatted = [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    secs.toString().padStart(2, '0')
  ].join(':');

  const formattedMs = ms.toString().padStart(3, '0');

  if (!seconds) {
    return `00:00:00${msDelimiter}000`;
  }

  return (negative ? '-' : '') + formatted + msDelimiter + formattedMs;
};

/**
 * Formats seconds to mm:ss format
 * @param {number} seconds - The number of seconds
 * @returns {string} The formatted time
 */
export const formatMinutesSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Formats a date to the specified format
 * @param {string|Date} date - The date to format
 * @param {string} format - The format string (default: 'DD-MM-YYYY HH:mm')
 * @returns {string} The formatted date
 */
export const formatDate = (date, format = 'DD-MM-YYYY HH:mm') => {
  if (!date) return '-';
  return moment(date).format(format);
};

/**
 * Gets the time difference in hours between two dates
 * @param {string|Date} date - The date to compare
 * @returns {number} The time difference in hours
 */
export const getTimeDifferenceInHours = (date) => {
  return moment(date).diff(new Date(), 'hours');
};

/**
 * Gets a human-readable countdown from a date
 * @param {string|Date} date - The target date
 * @param {string} locale - The locale to use
 * @returns {string} The countdown text
 */
export const getCountdown = (date, locale) => {
  moment.locale(locale);
  return moment(date).from(new Date());
}; 